import React, { Component } from 'react';
import './NeighborhoodMap.css';
import ReactMapboxGl, { Layer, Source } from "react-mapbox-gl";
import Buttons from '../Buttons/Buttons.jsx';
import { getText } from '../AllTexts.jsx';

const Map = ReactMapboxGl({
    accessToken: "pk.eyJ1IjoibWF4cGxhbmNrLXN0YW1lbiIsImEiOiJjamwybmg5d2oxc2MwM3Buc3NyZHZpeG43In0.-pXSMRxrSkez55nLLEPnGQ"
});

const allVariables = () => {
    return {
        'superdiversity': {
            'vancouver': [
                {id: "Ethnic origin (normalized)", name: getText("Ethnic diversity")},
                {id: "Immigration generation (tertiles)", name: getText("Immigration generation diversity")},
                {id: "Income deciles (tertiles)", name: getText("Income diversity")},
                {id: "Education (tertiles)", name: getText("Education diversity")},
                {id: "Immigration category (tertiles)", name: getText("Immigration category diversity")},
                {id: "Mobility status 5 years ago (tertiles)", name: getText("Mobility")}
            ],
            'toronto': [
                {id: "ETHNIC_DIV", name: getText("Ethnic diversity")},
                {id: "GENERATION", name: getText("Immigration generation diversity")},
                {id: "INCOME_DIV", name: getText("Income diversity")},
                {id: "EDUCATION_", name: getText("Education diversity")},
                {id: "CATEGORY_D", name: getText("Immigration category diversity")},
                {id: "MOBILITY", name: getText("Mobility")}
            ]
        },
        'traditional': {
            'vancouver': [
                {id: "T_Immigrants", name: getText("Immigrant population"), max: 1.75, min: 0.5},
                {id: "T_Recent immigrants", name: getText("Recent immigrants"), max: 3, min: 0.25},
                {id: "T_South Asian VM", name: getText("South Asian VM"), max: 7},
                {id: "T_Filipino VM", name: getText("Filipino VM"), max: 5},
                {id: "T_Chinese VM", name: getText("Chinese VM"), max: 3.5},
                {id: "T_Top income quintile", name: getText("High income"), max: 2.5, min: 0.25}
            ],
            'toronto': [
                {id: "IMMIGRANTS", name: getText("Immigrant population"), max: 1.586, min: 0.246},
                {id: "RECENT_IMM", name: getText("Recent immigrants"), max: 6.72, min: 0},
                {id: "SOUTH_ASIA", name: getText("South Asian VM"), max: 5.99, min: 0},
                {id: "BLACK_VM", name: getText("Black VM"), max: 11.88, min: 0},
                {id: "CHINESE_VM", name: getText("Chinese VM"), max: 9.24, min: 0},
                {id: "TOP_INCOME", name: getText("High income"), max: 4.65, min: 0}
            ]
        }
    };
};

const defaultCenter = {vancouver: [-123.12, 49.23], toronto: [-79.399130, 43.646455] };
const defaultZoom = [10];

class Legend extends Component {
    render() {
        let keyClass;
        if (this.props.labels[0].id === this.props.labels[1].id) {
            keyClass = "hidden";
        } else {
            keyClass = "visible";
        }

        return <div id='key' className={keyClass}>
            <div className="row">
                <div className="sq" style={{backgroundColor: "#c06cba"}}></div>
                <div className="sq" style={{backgroundColor: "#7f679a"}}></div>
                <div className="sq" style={{backgroundColor: "#365f8d"}}></div>
            </div><div className="row">
                <div className="sq" style={{backgroundColor: "#98ade6"}}></div>
                <div className="sq" style={{backgroundColor: "#64a5be"}}></div>
                <div className="sq" style={{backgroundColor: "#459980"}}></div>
            </div><div className="row">
                <div className="sq" style={{backgroundColor: "#add5e9"}}></div>
                <div className="sq" style={{backgroundColor: "#72cbc1"}}></div>
                <div className="sq" style={{backgroundColor: "#4ebc82"}}></div>
            </div>
            <div id="xaxis">{this.props.labels[1].name}</div>
            <div id="yaxis">{this.props.labels[0].name}</div>
        </div>
    }
}

class Controls extends Component {
    render() {
        let active_ids = this.props.active.map((v) => v.id);

        return <div id="controls">
            {this.props.variables.map((v, i) => {
                return <div key={v.id} className={active_ids.indexOf(v.id) >= 0 ? "active" : ""}
                            onClick={() => this.props.callback(i)}>{v.name}</div>;
            })}
        </div>
    }
}

class NeighborhoodMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            switcher: 0
        }
    }

    updateVariables(newv) {
        if (this.props.mode === 'traditional') {
            this.props.update({variables: [newv, newv]});
            return;
        }

        if (this.state.switcher === 0) {
            this.props.update({variables: [newv, this.props.variables[1]]});
            this.setState({switcher: 1});
        } else {
            this.props.update({variables: [this.props.variables[0], newv]});
            this.setState({switcher: 0});
        }
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.mode != this.props.mode) {
            this.props.update({variables: [0, 0]});
            return false;
        }

        if (newProps.variables[0] >= allVariables()[newProps.mode][newProps.city].length) {
            this.props.update({variables: [0, this.props.variables[1]]});
            return false;
        }

        if (newProps.variables[1] >= allVariables()[newProps.mode][newProps.city].length) {
            this.props.update({variables: [this.props.variables[0], 1]});
            return false;
        }

        return true;
    }

    generatePaint(variables) {
        // This is a crazy mapboxgl function that returns 1 of 9 different colors
        // depending on the values of two properties of a feature. Each property
        // can take one of three values [1, 2, or 3], so there are 3 * 3 = 9
        // possible combinations. I wish mapboxgl functions weren't so difficult to read.
        if (this.props.mode === 'superdiversity') {
            return ["match", ["get", allVariables()[this.props.mode][this.props.city][variables[0]].id],
                3, ["match", ["get", allVariables()[this.props.mode][this.props.city][variables[1]].id], 1, "#c06cba", 2, "#7f679a", 3, "#365f8d", "#dddddd"],
                2, ["match", ["get", allVariables()[this.props.mode][this.props.city][variables[1]].id], 1, "#98ade6", 2, "#64a5be", 3, "#459980", "#dddddd"],
                1, ["match", ["get", allVariables()[this.props.mode][this.props.city][variables[1]].id], 1, "#add5e9", 2, "#72cbc1", 3, "#4ebc82", "#dddddd"], "#dddddd"];
        } else {
            return ["interpolate", ["linear"], ["get", allVariables()[this.props.mode][this.props.city][variables[0]].id], allVariables()[this.props.mode][this.props.city][variables[0]].min || 0, "#d3e5e8", allVariables()[this.props.mode][this.props.city][variables[0]].max, "#2e648c"];
        }
    }

    generateFilter() {
        return ["has", allVariables()[this.props.mode][this.props.city][this.props.variables[0]].id];
    }

    updateFilter(newv) {
        this.props.update({mode: newv});
    }

    render() {

        let values = [{display: getText("Traditional maps"), value: "traditional"}, {display: getText("Superdiversity maps"), value: "superdiversity"}];

        return <React.Fragment>
            <Buttons
                values={values}
                callback={this.updateFilter.bind(this)}
                selected={this.props.mode}
              />
            <div id="neighborhoodmap">
            <Legend
                labels={this.props.variables.map(i => allVariables()[this.props.mode][this.props.city][i])} />
            <Controls
                variables={allVariables()[this.props.mode][this.props.city]}
                callback={this.updateVariables.bind(this)}
                active={this.props.variables.map(i => allVariables()[this.props.mode][this.props.city][i])} />
            <Map
                style="mapbox://styles/maxplanck-stamen/cjtug360h03oh1eqsa4keicyi"
                center={defaultCenter[this.props.city]}
                zoom={defaultZoom}
                minZoom={6}
                containerStyle={{
                    height: "750px",
                    width: "100%"
                }}>
                <Source
                    id="vancouver"
                    key="vancouver"
                    geoJsonSource={{type: "vector", url: "mapbox://maxplanck-stamen.5b30bhw9"}}
                />
                <Source
                    id="toronto"
                    key="toronto"
                    geoJsonSource={{type: "vector", url: "mapbox://maxplanck-stamen.5m26v5z9"}}
                />
                <Layer
                    id="data-fill-vancouver"
                    sourceId="vancouver"
                    type="fill"
                    sourceLayer="joined_w_trad-7ro5de"
                    filter={this.generateFilter()}
                    paint={{
                        'fill-color': this.generatePaint(this.props.variables),
                        'fill-opacity': 0.8
                    }}
                    before="waterway-river-canal"
                ></Layer>
                <Layer
                    id="data-fill-toronto"
                    sourceId="toronto"
                    type="fill"
                    sourceLayer="torontojoined"
                    filter={this.generateFilter()}
                    paint={{
                        'fill-color': this.generatePaint(this.props.variables),
                        'fill-opacity': 0.8
                    }}
                    before="waterway-river-canal"
                ></Layer>
            </Map>
        </div>
        </React.Fragment>
    }
}

export default NeighborhoodMap;



// WEBPACK FOOTER //
// ./src/NeighborhoodMap/NeighborhoodMap.jsx